import request from 'src/utils/request';

const AdminService = {
    async list(
        params = {
            page: 1,
            page_size: 20,
            active: 1,
        }
    ) {
        const { data } = await request.get('/admin/admin', { params });
        return data;
    },
    async leaders(
        params = {
            page: 1,
            page_size: 20,
        }
    ) {
        const { data } = await request.get('/admin/admin/leaders', { params });
        return data;
    },
    async show(id) {
        return await request.get(`/admin/admin/${id}`);
    },
    async update(id, data) {
        delete data.id;
        return await request.put(`/admin/admin/${id}`, data);
    },
    async create(data) {
        return await request.post(`/admin/admin`, data);
    },
    async delete(id) {
        return await request.delete(`/admin/admin/${id}`);
    },
};

export default AdminService;
